import type { AnswerT, LabelValidationSuggestionT } from '../types/types';
export function extractTextualAnswers(answers: AnswerT): Array<{
  questionId: string;
  text: string;
}> {
  const textualAnswers: Array<{
    questionId: string;
    text: string;
  }> = [];
  Object.entries(answers).forEach(([questionId, answerData]) => {
    answerData.answers.forEach(answer => {
      if (typeof answer === 'string' && answer.trim().length > 0) {
        textualAnswers.push({
          questionId,
          text: answer.trim()
        });
      }
    });
  });
  return textualAnswers;
}
export function generateSuggestionId(): string {
  return `suggestion_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}
export function hasPendingSuggestions(suggestions: LabelValidationSuggestionT[]): boolean {
  return suggestions.length > 0;
}
export function getSuggestionsForQuestion(suggestions: LabelValidationSuggestionT[], questionId: string): LabelValidationSuggestionT[] {
  return suggestions.filter(suggestion => suggestion.questionId === questionId);
}